module.exports = __webpack_public_path__ + "static/img/video_cover7.e6dded85.png";